module.exports = __webpack_public_path__ + "img/159d97da4d57d8af0e1998517825717b.png";